import { Link } from "react-router-dom";

import withLayoutOptions from "../../components/withLayoutOptions/withLayoutOptions";

import useImgSet from "../../hooks/useImgSet";

import s from "./PageKidA.module.scss";

function PageKidA() {
  const getImgSet = useImgSet();

  const description = getImgSet("description__p03", "png", s.description);
  const item01 = getImgSet("item__01__p03", "png", [s.item, s.item__01]);
  const pointer = getImgSet("pointer__kid", "png", s.pointer);

  const back = getImgSet("back__p22", "png");
  const imgA = getImgSet("bear__03", "png", s.img__a);

  return (
    <div className={s.root}>
      {pointer}
      <div className={s.aside_left}>
        <Link to="/kid/" className={s.back}>
          {back}
        </Link>
        {imgA}
      </div>
      <div className={s.inner}>{item01}</div>
      <div className={s.aside_right} />
      <div className={s.footer}>{description}</div>
    </div>
  );
}

export default withLayoutOptions(PageKidA);
